import { dateAsString } from './dates';

export const sendEvent = (data) => {
  if (!window.dataLayer) window.dataLayer = [];
  window.dataLayer.push(data);
};

export const sendPageView = (contentType, pageTitle, createdAt, updatedAt) =>
  sendEvent({
    contentType,
    pageTitle,
    contentPublishedDate: !createdAt
      ? 'unavailable'
      : dateAsString(createdAt, 'DD/MM/YYYY'),
    contentModifiedDate: !updatedAt
      ? 'unavailable'
      : dateAsString(updatedAt, 'DD/MM/YYYY'),
  });

export const shouldRedactPixels = (pageType, path, allowTracking) => {
  if (!path) return false;

  const isSensitivePage =
    pageType === 'ContentfulPageAdvice' ||
    (process.env.SHELTER_SITE === 'england' && !!path.match(/^\/get_help/)) ||
    (process.env.SHELTER_SITE === 'scotland' &&
      !!path.match(/^\/about_us\/contact_us/));

  // All non sensitive pages should not redact pixels
  if (!isSensitivePage) return false;

  // sensitive page but has opted in to tracking via cms, don't redact pixels
  if (allowTracking === true) return false;

  // sensitive page and hasn't opted in to tracking, redact pixels
  return true;
};
